import React from 'react';
import { Popover, PopoverContent, PopoverTrigger, Skeleton, } from '@cargomatic/ui';
import { useShipperInvoiceConfig } from './hooks/useShipperInvoiceConfig';
function humanizeGrouping(grouping) {
    if (!grouping)
        return 'Not Specified';
    return grouping
        .toLowerCase()
        .split('_')
        .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ''))
        .join(' ');
}
export default function InvoiceConfiguration({ shipperId }) {
    const { data, isLoading } = useShipperInvoiceConfig(shipperId);
    return (React.createElement(Popover, null,
        React.createElement(PopoverTrigger, { asChild: true },
            React.createElement("button", { className: "text-sm text-muted-foreground hover:text-foreground transition-colors underline decoration-dotted" }, "Invoice Configuration")),
        React.createElement(PopoverContent, { className: "w-auto p-3", align: "end" }, isLoading ? (React.createElement("div", { className: "flex flex-col gap-2" },
            React.createElement(Skeleton, { className: "h-4 w-56" }),
            React.createElement(Skeleton, { className: "h-4 w-64" }))) : (React.createElement("div", { className: "flex flex-col gap-2" },
            React.createElement("div", { className: "bg-blue-50 dark:bg-blue-950 px-3 py-2 rounded text-sm text-blue-900 dark:text-blue-100 whitespace-nowrap" },
                "Invoice Grouping: ",
                humanizeGrouping(data === null || data === void 0 ? void 0 : data.invoiceGrouping)),
            React.createElement("div", { className: "bg-purple-50 dark:bg-purple-950 px-3 py-2 rounded text-sm text-purple-900 dark:text-purple-100 whitespace-nowrap" },
                "Pending Accessorial Billing Status Evaluation:",
                ' ',
                (data === null || data === void 0 ? void 0 : data.includePendingAccessorials) ? 'Yes' : 'No'))))));
}
